import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import {
  SaleHorse,
  SaleHorseStatus,
  SaleHorseSubmissionsStatusIds,
  SaleHorseTableFields,
} from 'src/app/models/sales/sale-horse.model';
import { Sale } from 'src/app/models/sales/sales.model';
import { SalesService } from 'src/app/services/sales.service';
import { ViewerService } from 'src/app/services/viewer.service';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { Helper } from 'src/app/utils/helper/helper';
import swal from 'sweetalert2';
import { SaleSettingModel } from '../../models/sales/sale-settings.model';
import { SaleHorseStudyFiles } from '../../models/sales/sale-horse-study-files.model';
import { StudyMimeType } from '../../shared-new/enums/study-mime-type.enum';
import { StudyStatus } from '../../shared-new/enums/study-status.enum';

import { AuthService } from '../../services/auth.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { EventsEmitter } from '../../shared/event-emitter/EventEmitter';

import { DateParserFormatter } from '../../utils/helper/date-parser-formatter';
import { SaleHorseInternalNotePopupComponent } from '../sale-horse-internal-note-popup/sale-horse-internal-note-popup.component';
import { SaleHorseScopeViewerPopupComponent } from '../sale-horse-scope-viewer-popup/sale-horse-scope-viewer-popup.component';
import { SaleHorseXRayReportsPopupComponent } from '../sale-horse-xray-reports-popup/sale-horse-xray-reports-popup.component';
import { EmailStudyDataModalComponent } from '../email-study-data-modal/email-study-data-modal.component';
import { SaleHorseListDataSource } from './sale-horse-list-datasource';
import { SaleResultEnum } from '../../shared-new/enums/sale-result.enum';

@Component({
  selector: 'app-sale-horse-list',
  templateUrl: './sale-horse-list.component.html',
  styleUrls: ['./sale-horse-list.component.scss'],
  providers: [Helper],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaleHorseListComponent
  extends BaseUnsubscribeComponent
  implements OnInit, AfterViewInit {
  @ViewChild(MatSort) horseSort: MatSort;
  public _sale: Sale;
  public isLoader = false;
  public lotOrHipText: string;
  StudyStatus = StudyStatus;

  public studyFiles: SaleHorseStudyFiles[];
  public studyMimeType = StudyMimeType;
  @Input() set sale(value: Sale) {
    this._sale = value;
    this.lotOrHipText = value?.lotOrHipText;
  }

  @Input() set saleHorses(value: SaleHorse[]) {
    this._saleHorses = value;
    setTimeout(() => {
      this.onInitSaleHorses();
    },100)
   
  }

  @Input() set searchTerm(value: string) {
    this._searchTerm = value;
    this.searchDataSource(value);
  }

  @Input() public tab: string;
  private _saleHorse: SaleHorse = null;
  private _saleHorses: SaleHorse[] = null;
  private _searchTerm: string;
  public userId: number;
  public memberId: number;
  public switchTab: string;
  @Input() public isLoaderSaleHorses: boolean = true;

  @ViewChild('matTable', { static: false, read: MatTable }) table!: MatTable<SaleHorse>;
  @Output() openStudyFilePopup = new EventEmitter();
  @Output() openSaleHorseStatusPopup = new EventEmitter();
  @Output() clearSearch = new EventEmitter();
  public checkedAll = false;
  private readonly destroy$ = new Subject<void>();
  // public dataSource: SaleHorseListDataSource;
  public dataSource: SaleHorseListDataSource;
  public columns = [
    'lotNumber',
    'horseName',
    'horseAgeCategoryName',
    'consignor',
    'accessionCode',
    'submissionStatus',
    'xrayStatus',
    'scopeStatus',
    'xrayReportStatus',
    'saleResult',
    'notes',
    'action',
  ];
  public displayedColumns$ = new BehaviorSubject(this.columns);

  public closeResult = '';
  private _saleSetting: SaleSettingModel = null;
  @Input() public set saleSetting(settings: SaleSettingModel) {
    this._saleSetting = settings;
  }
  public get saleSetting(): SaleSettingModel {
    return this._saleSetting;
  }
  @Input() set updateSaleHorses(values: SaleHorseStatus[]) {
    if (!values || !this._saleHorses || values.length === 0) return;

    this.updateSaleHorseStatusInList(values);
  }

  @Input() set updateSaleHorse(value: SaleHorse) {
    if (!value || !this._saleHorses) return;

    this.updateSaleHorseInList(value);
  }


  public saleHorseTableFields = SaleHorseTableFields;
  public saleHorseSubmissionsStatusIds = SaleHorseSubmissionsStatusIds;
  isSalesCompany = false;

  public filter = {
    all: false,
    draft: false,
    approved: false,
    pending: false,
    denied: false,
    inReview: false,
  };
  submissionFilter: SaleHorseSubmissionsStatusIds = null;

  selectedFilters: number[] = [];

  constructor(
    private readonly salesService: SalesService,
    private readonly modalService: NgbModal,
    private readonly helper: Helper,
    public readonly authService: AuthService,
    private viewerService: ViewerService,
    private route: ActivatedRoute,
    private changeDetectorRefs: ChangeDetectorRef,
    private toastService: ToastService,
    private eventEmitter: EventsEmitter,
    private readonly dateParserFormatter: DateParserFormatter

  ) {
    super();
  }

  public ngOnInit(): void {
    
    this.isLoader = true;
    this.isSalesCompany = this.authService.IsSalesCompany();
    // Remove the 'notes' column if isSalesCompany is false
    if (!this.isSalesCompany) {
      this.columns = this.columns.filter((column) => column !== 'notes');
    }
    this.displayedColumns$.next(this.columns);    
   


  }
  trackById(index: number, item: SaleHorse): any {
    return item.horseId;
  }

  ngAfterViewInit(): void {

  }
  private onInitSaleHorses() {
    if (this._saleHorses) {
      if (this.horseSort) {
       
        const event = {
          srcElement: {
            checked: false
          }
        }
        this.updateSaleSubmissionFilter(this.getSaleHorseSubmissionStatusSelectedTabByFilter(this.filter), event);
      }
    }
   // this.changeDetectorRefs.markForCheck();
  }

  public get allSaleHorseCount() {
   return this._saleHorses?.length ?? 0;
  }
  private searchDataSource(searchTerm: string) {
    if (searchTerm == undefined || searchTerm == null) {
      return;
    }
    if (this.dataSource) {
      if (searchTerm === '') {
        this.dataSource?.clearFilter(); // Add a method to reset the data
      } else {
        this.dataSource.searchTable(searchTerm);
      }
    } 
  }


  getDicomFiles() {
    const dicomFiles = this.studyFiles
      ?.filter((file) => file.studyFileMimeTypeId === StudyMimeType.XRAY)
      .sort((a, b) => {
        const dateA = new Date(a.createdDate).getTime();
        const dateB = new Date(b.createdDate).getTime();
        return dateA - dateB;
      });

    return dicomFiles;
  }

  getScopeFiles() {
    const dicomFiles = this.studyFiles
      ?.filter((file) => file.studyFileMimeTypeId === StudyMimeType.SCOPE_VIDEO)
      .sort((a, b) => {
        const dateA = new Date(a.createdDate).getTime();
        const dateB = new Date(b.createdDate).getTime();
        return dateA - dateB;
      });

    return dicomFiles;
  }

  getReportFiles() {
    const dicomFiles = this.studyFiles
      ?.filter((file) => file.studyFileMimeTypeId === StudyMimeType.XRAY_REPORT)
      .sort((a, b) => {
        const dateA = new Date(a.createdDate).getTime();
        const dateB = new Date(b.createdDate).getTime();
        return dateA - dateB;
      });

    return dicomFiles;
  }
  openEmailStudyDataPopup(saleHorse: SaleHorse): void {

    
    this.salesService
      .getSaleHorseStudyFiles(saleHorse.saleId, saleHorse.horseId)
      .subscribe(
        (response) => {
          
        this.studyFiles = response?.filter((f) => f.studyStatusId == StudyStatus.Approved);
            this.isLoader = false;
            const modalRef = this.modalService.open(EmailStudyDataModalComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });

    const dicomFiles = this.getDicomFiles();
    const reportFiles = this.getReportFiles();
    const scopeFiles = this.getScopeFiles();
    modalRef.componentInstance.studyId = 1;//this.studyId;
    modalRef.componentInstance.fileInfo = {
      xrayCount: dicomFiles.length,
      reportFiles: reportFiles,
      scopeFiles: scopeFiles,
      studyId: null,
      saleId: saleHorse?.saleId,
      horseId: saleHorse?.horseId,
      sale: this._sale,
      lotNumber: saleHorse.lot,
      lotOrHipText: this.lotOrHipText,
    };
    modalRef.closed.subscribe((res) => {
      // console.log(res);
    });
          
        },
        (errorResponse: Error) => {
          const errorData = JSON.parse(JSON.stringify(errorResponse));
          if (errorData?.error) {
            if (errorData?.status === 401 || errorData?.status === 500) {
              this.toastService.error(errorData.error.message);
            }

            if (errorData?.status === 400) {
              let errorMessages = '';
              if (errorData.error instanceof Array) {
                errorData.error.forEach((value: { message: string }) => {
                  errorMessages += value.message + '<br>';
                });
              } else {
                errorMessages = errorData.error.message;
              }

              this.toastService.error(errorMessages);
            }
          }

          this.isLoader = false;
        }
      );


    
  }
  openInternalNotePopup(saleId: number, horseId: number, lot: string) {
    const modalRef = this.modalService.open(
      SaleHorseInternalNotePopupComponent,
      {
        ariaLabelledBy: horseId + 'Id',
        centered: true,
        size: 'lg',
        keyboard: false,
        backdrop: 'static',
      }
    );

    modalRef.componentInstance.data = {
      saleId: saleId,
      horseId: horseId,
      lot: lot,
    };
    modalRef.result.then(
      (result) => {
        const data = JSON.parse(result);

        var submitFormData = {
          id: data.id,
          saleId: data.saleId,
          horseId: data.horseId,
          notes: data.note,
        };

        this.salesService.postSaleHorseNotes(submitFormData).subscribe(
          (response) => {
            if (response) {
              this.toastService.success(
                'Note has been saved successfully',
                'Success!'
              );
              this.updateNotesIcon(saleId, horseId);
            }
          },
          (errorResponse: Error) => {
            const errorData = JSON.parse(JSON.stringify(errorResponse));
            if (errorData?.error) {
              if (errorData?.status === 401 || errorData?.status === 500) {
                swal.fire('Alert', errorData.error.message, 'error');
              }

              if (errorData?.status === 400) {
                let errorMessages = '';
                if (errorData.error instanceof Array) {
                  errorData.error.forEach((value: { message: string }) => {
                    errorMessages += value.message + '<br>';
                  });
                } else {
                  errorMessages = errorData.error.message;
                }

                swal.fire('Alert', errorMessages, 'error');
              }
            }
          }
        );
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.updateNotesIcon(saleId, horseId);
      }
    );
  }
  private updateNotesIcon(saleId: number, horseId: number) {
    this.isLoaderSaleHorses = true;
    this.salesService
      .getSaleHorseNotes(saleId, horseId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.isLoaderSaleHorses = false;
        this.dataSource.updateNotesCount(horseId, response.length);
        this.table.renderRows();
        this.changeDetectorRefs.detectChanges();
      });
  }
  openStudyFilePopupTrigger(saleHorse: SaleHorse, event: any) {
    // Check if the clicked element is not in the 'action' column
    if (
      !event.target.classList.contains('fa-ellipsis-v') &&
      !event.target.classList.contains('dropdown-item')
    ) {
      this.openStudyFilePopup.emit(saleHorse);
    }
  }
  openSaleHorseStatusPopupTrigger(saleHorse: SaleHorse, event: any) {
    //
    if (this.isSalesCompany) {
      this.openSaleHorseStatusPopup.emit(saleHorse);
    }
  }
  openScopeViewerPopup(saleId: number, horseId: number) {
    const modalRef = this.modalService.open(
      SaleHorseScopeViewerPopupComponent,
      {
        ariaLabelledBy: horseId + 'Id',
        centered: true,
        size: '75-width',
        keyboard: false,
        backdrop: 'static',
      }
    );

    modalRef.componentInstance.data = { saleId: saleId, horseId: horseId };
    modalRef.result.then(
      (result) => {},
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openXRayReportPopup(saleId: number, horseId: number) {
    const modalRef = this.modalService.open(
      SaleHorseXRayReportsPopupComponent,
      {
        ariaLabelledBy: horseId + 'Id',
        centered: true,
        size: '75-width',
        keyboard: false,
        backdrop: 'static',
      }
    );

    modalRef.componentInstance.data = { saleId: saleId, horseId: horseId };
    modalRef.result.then(
      (result) => {},
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public sortTableOnHorse(sortOn: string) {
    this.dataSource.setSortOn(sortOn);
  }

  public async viewStudy(
    saleId: number,
    horseId: number,
    seriesInstanceUID: string
  ) {
    if (this.saleSetting.xRays) {
      swal
        .fire({
          title: 'X-Ray Images',
          text: 'Enter Client Name',
          input: 'text',
          showCancelButton: true,
          confirmButtonText: 'View',
          confirmButtonColor: '#1b6da6',
        })
        .then(async (result) => {
          if (result.value) {
            let val: string = result.value as string;
            this.isLoaderSaleHorses = true;
            await this.viewerService.openDicomViewrForHorseStudy(
              saleId,
              horseId,
              seriesInstanceUID,
              val
            );
            this.isLoaderSaleHorses = false;
          }
        });
    } else {
      this.isLoaderSaleHorses = true;
      await this.viewerService.openDicomViewrForHorseStudy(
        saleId,
        horseId,
        seriesInstanceUID
      );
      this.isLoaderSaleHorses = false;
    }
  }

  trackByGroup(index: number, el: SaleHorse): number {
    return el.horseId;
  }

  public onTableScroll(): void {
    this.dataSource?.onScroll();
  }

  public getFiltersCount(statusId: SaleHorseSubmissionsStatusIds): number {
    if (this._saleHorses) {
      const filteredRecords = this._saleHorses.filter((saleHorse) => {
        return saleHorse.submissionStatusId === statusId;
      });
      return filteredRecords?.length;
    }
    return 0;
  }

  public getFiltersRecords(statusId: SaleHorseSubmissionsStatusIds): SaleHorse[] {
    if (!statusId) {
      return this._saleHorses;
    }
    if (this._saleHorses) {
      const filteredRecords = this._saleHorses.filter((saleHorse) => {
        return saleHorse.submissionStatusId === statusId;
      });
      return filteredRecords;
    }
    return null;
  }
  getSaleHorseSubmissionStatusSelectedTabByFilter(
    filter: {
      approved?: boolean;
      denied?: boolean;
      draft?: boolean;
      inReview?: boolean;
      pending?: boolean;
      all?: boolean;
    }
  ): SaleHorseSubmissionsStatusIds {

    if (filter.approved) {
      return SaleHorseSubmissionsStatusIds.APPROVED;
    }

    if (filter.denied) {
      return SaleHorseSubmissionsStatusIds.DENIED;
    }

    if (filter.draft) {
      return SaleHorseSubmissionsStatusIds.DRAFT;
    }

    if (filter.inReview) {
      return SaleHorseSubmissionsStatusIds.IN_REVIEW;
    }

    if (filter.pending) {
      return SaleHorseSubmissionsStatusIds.PENDING;
    }

    return null;
  }

  updateSaleSubmissionFilter(data: SaleHorseSubmissionsStatusIds, event: any) {
    this.filter.all = false;
    this.filter.approved = false;
    this.filter.denied = false;
    this.filter.draft = false;
    this.filter.inReview = false;
    this.filter.pending = false;
   // this.clearSearch.emit();

      switch (data) {
        case SaleHorseSubmissionsStatusIds.APPROVED:
          this.filter.approved = true;
          this.filter.all = false;
          break;
        case SaleHorseSubmissionsStatusIds.DENIED:
          this.filter.denied = true;
          this.filter.all = false;
          break;

        case SaleHorseSubmissionsStatusIds.DRAFT:
          this.filter.draft = true;
          this.filter.all = false;
          break;

        case SaleHorseSubmissionsStatusIds.IN_REVIEW:
          this.filter.inReview = true;
          this.filter.all = false;
          break;

        case SaleHorseSubmissionsStatusIds.PENDING:
          this.filter.pending = true;
          this.filter.all = false;
          break;

        default:
          this.filter.all = true;
          break;
      }

    const saleHorses = this.getFiltersRecords(data);
    this.dataSource = new SaleHorseListDataSource(saleHorses, this.horseSort, false, this.dataSource?.infiniteScrollLevel || 20);
    this.dataSource.applyDefaultSort();
    this.searchDataSource(this._searchTerm);
  }

  private updateSaleHorseInList(updatedHorse: SaleHorse): void {
    if (!updatedHorse || !this._saleHorses) return;

   
    // Build map from existing list (fast lookups)
    const map = new Map<number, SaleHorse>(
      this._saleHorses.map(h => [h.horseId, h])
    );

      // Update or insert
      map.set(updatedHorse.horseId, {
        ...map.get(updatedHorse.horseId),
        ...updatedHorse,
        hidden: false
      });
    

    // Rebuild list immutably
    this._saleHorses = Array.from(map.values());

    this.rebuildDataSourcePreservingState();
  }

  private updateSaleHorseStatusInList(updatedHorses: SaleHorseStatus[]): void {
    if (!updatedHorses?.length || !this._saleHorses) return;

    const isSalesCompany = this.authService.IsSalesCompany();

    const hiddenStatuses = new Set([
      SaleResultEnum.Withdrawn,
      SaleResultEnum.WithdrawnAtSale,
      SaleResultEnum.Sold,
      SaleResultEnum.PrivateSale
    ]);

    // Build map from existing list (fast lookups)
    const map = new Map<number, SaleHorse>(
      this._saleHorses.map(h => [h.horseId, h])
    );

    for (const updatedHorse of updatedHorses) {

      // Remove horse if it becomes hidden for non-sales users
      if (
        !isSalesCompany &&
        hiddenStatuses.has(updatedHorse.status)
      ) {
        map.set(updatedHorse.horseId, {
          ...map.get(updatedHorse.horseId),
          hidden: true
        });
        continue;
      }

      // Update or insert
      map.set(updatedHorse.horseId, {
        ...map.get(updatedHorse.horseId),
        saleResult: updatedHorse.saleResult,
        hidden: false
      });
    }

    // Rebuild list immutably
    this._saleHorses = Array.from(map.values());

    this.rebuildDataSourcePreservingState();
  }


  private rebuildDataSourcePreservingState(): void {
    const currentScrollLevel =
      this.dataSource?.infiniteScrollLevel || 20;

    const currentFilter =
      this.getSubmissionStatusFromFilter();

    const filteredData =
      this.getFiltersRecords(currentFilter);

    this.dataSource = new SaleHorseListDataSource(
      filteredData,
      this.horseSort,
      false,
      currentScrollLevel
    );

    this.dataSource.applyDefaultSort();
    this.searchDataSource(this._searchTerm);

    //force render (mat-table + OnPush)
    this.table?.renderRows();
    this.changeDetectorRefs.markForCheck();
  }


  getSubmissionStatusFromFilter(): SaleHorseSubmissionsStatusIds {
    if (this.filter.approved) return SaleHorseSubmissionsStatusIds.APPROVED;
    if (this.filter.denied) return SaleHorseSubmissionsStatusIds.DENIED;
    if (this.filter.draft) return SaleHorseSubmissionsStatusIds.DRAFT;
    if (this.filter.inReview) return SaleHorseSubmissionsStatusIds.IN_REVIEW;
    if (this.filter.pending) return SaleHorseSubmissionsStatusIds.PENDING;
    return null;
  }
  public getSaleDateFormat() {
    return this.dateParserFormatter.getDateFormatForSale(this._sale, false);
  }
}
